module.exports = __webpack_public_path__ + "img/68.e5b47e6.png";